import React, { useEffect } from "react";
import REST from '../../libs/API';
import { useCookies } from "react-cookie";

export default function ExternalAuth(props) {
  const [cookies, setCookie, removeCookie] = useCookies();

  useEffect(() => {
    const cookieRef = cookies["refCode"]
    const refString = cookieRef ? "&refCode=" + cookieRef : "";
    
    REST.getSocAuthLogin(window.location.search + refString).then(data => {
      if (data.data.success) {
        window.opener && window.opener.catchSocAuthToken(data)
        window.close();
      } else {
        window.showMessage(data.data.message);
      }
    })
  }, []);

  return (
    <div>

    </div>
  )
}